<template>
    <el-row style="height:100%;">
        <el-col style="height:100%;" :xs="24" :sm="24" :md="{ span: 16, offset: 4 }" :lg="{ span: 14, offset: 5 }" :xl="{ span: 12, offset: 6 }">
            <div id="bk">
                <div class="main">
                    <img class="logo" src="static/logo.png"/>
                    <quill-editor id="editor" class="editor" ref="editor" :options="editorOption" :disabled='step > 1'
                        v-model="content"></quill-editor>
                    <div class="tip">
                        <div style="font-weight:bold;padding: 10px 0px;">使用说明：</div>
                        <ul>
                            <li>网站只存储加密后的信息，返回给你一个访问链接</li>
                            <li>用链接可无须登陆直接取回加密后的信息，但需要自己解密</li>
                            <li>或者把下载的内容粘贴在这里帮你解密</li>
                            <li>加密算法采用AES，使用crypto-js库，<el-button style="font-size: inherit;" type="text"
                                    @click="onShowCode">参考代码</el-button>
                                <pre v-if="bShowCode">
                                <code>
    // 加密
    function aesEncrypt(data, key) {
        var encrypted = CryptoJS.AES.encrypt(data, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    }

    // 解密
    function aesDecrypt(ciphertext, key) {
        var decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
                                    </code>
                                    </pre>
                            </li>
                            <li>信息大小限制为10M</li>
                            <li>信息免费保留24小时，每日可下载250次，超限删除</li>
                            <li>如果需要更多的保留时间和下载次数请联系QQ：642128162购买延期代码</li>
                        </ul>

                    </div>
                    <div class="tool" v-if="!bShowCaptcha">
                        <el-input class="input" v-model="password" placeholder="请输入密码"
                            placeholderStyle="color:#999;"></el-input>
                        <el-input class="input" v-model="delayCode" placeholder="延期代码(可选)"
                            placeholderStyle="color:#999;"></el-input>
                        <el-button type="primary" class="btn" @click="onEncryp" size="small">加密存储</el-button>
                        <el-button type="primary" class="btn" @click="onDecryp" size="small">解密</el-button>
                    </div>
                    <div v-else class="captchaview" title="人机验证">
                        <img style="width:144px; height:144px; margin: 0 auto;" :src="qrCode" alt="QR Code" />
                        <p style="color:#333; font-size: 14px; text-align: center; padding: 10px;">
                            请用任意微信扫码证明您是真实用户, 如果您用手机使用本网站，请截图后再用微信扫码</p>
                    </div>

                </div>
                <div class="footer">
                    <el-link type="primary" href="https://beian.miit.gov.cn/">蜀ICP备2021013463号-2</el-link>
                </div>
            </div>

            <div class="uploadprogress" v-if="bUploadDlg">
                <div class='uploadcenter'>

                    <el-progress class="progressCircle" type="circle" :stroke-width="12" :width="140"
                        v-if="uploadProgress === 100" :percentage="uploadProgress" status="success"></el-progress>

                    <p class="uploadtip">上传完成，请记住你的下载链接:</p>
                    <el-link class="downUrl" :href="downloadUrl">{{ downloadUrl }}</el-link>
                    <div class="toolbar">
                        <el-button class="uploadbtn" type="success" @click="onCopyUrl" size="small">复制链接</el-button>
                        <el-button class="uploadbtn" type="success" @click="onUploadOK" size="small">关闭</el-button>
                    </div>

                </div>
            </div>
        </el-col>
    </el-row>
</template>

<style>
#bk {
    min-height: 100vh;
    width: 100%;
    font-size: 18px;
    display: flex;
    flex-direction:column;
    background: #fff;
}

el-row{
    display: block;
    height:100%;
}
.main {
    width: 100%;
    flex:auto;
    /* border: 1px solid #333; */
    background: #fff;
    box-sizing: border-box;
    margin: 0 auto;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
}


.logo {
    width: 3.75rem;
    height: 1rem;
    margin: 4px auto;
    display: block;
}

.footer {
    flex:none;
    width: 100%;
    display: block;
    text-align: center;
    padding: 10px 0;
}

.slogan {
    text-align: center;
    margin: 8px;
    font-weight: 200;
    color: #000;
}

.quill-editor {
    /* border: 1px solid #ddd; */
    background-color: #fff;
    width: 90%;
    margin: 0 auto;
    flex:auto;
    display: flex;
    flex-direction: column;
}

.ql-container {
    flex: auto;
}

.tool {
    padding: 10px;
    display: flex;
    justify-content: space-around;
}

.captchaview {
    width: 100%;
    text-align: center;
}

.input {
    width: 200px;
    margin: 0 10px;
    border: 1px solid #999;
    border-radius: 4px;
}

.btn {
    margin: 0 10px;
}

.tip {

    padding: 10px 50px;
    color: #333;
    font-size: 12px;
}


.uploadprogress {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 1000;
}

.uploadcenter {
    position: relative;
    width: 500px;
    height: 300px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.progressCircle {
    left: 50%;
    transform: translateX(-50%);
}

.uploadcell {
    flex: auto;
    text-align: center;
    color: #fff;
    width: 100px;
    height: 40px;
    line-height: 40px;
}

.uploadtip {
    text-align: center;
    font-size: 14px;
    color: #fff;
    font-size: 18px;
    margin: 8px;

}

.downUrl {
    color: #000;
    text-align: center;
    font-size: 22px;
    padding: 0.106667rem;
    background: #e9e7ef;
    margin: 12px;
    word-break: break-all;
    border-radius: 4px;
    width: 100%;
}

.toolbar {
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: space-around;
}
</style>

<script>

const util = require('../util')

var _taskID = null

function getBytesLength(str) {
    let buf = Buffer.from(str)
    return buf.length

}

export default {
    name: 'bk',
    components: {},
    data() {
        return {
            bUploadDlg: false,
            downloadUrl: '',
            content: '',
            password: '',
            bShowCaptcha: false,
            authCode: '',
            qrCode: '',
            uploadSpeed: 0,
            uploadProgress: 0,
            bShowCode: false,
            delayCode: ''
        }
    },
    methods: {
        async onEncryp() {
            if (!this.password) {
                this.$msgbox({
                    title: '错误',
                    message: '请输入加密密码'
                })
                return
            }

            var n = getBytesLength(this.content)
            if (n === 0) {
                this.$msgbox({
                    title: '请先输入留言'
                })
                return
            }
            if (n > 1024 * 1024 * 10) {
                this.$msgbox({
                    title: '留言大小超过5M，请减少内容'
                })
                return
            }


            let text = util.Encrypted(this.password, this.content) //加密ID作为检测用户密码输入是否正确的依据

            console.log("加密结果：", text)
            console.log("解密测试：", util.Decrypted(this.password, text))

            let id = util.SHA1(text)

            var loading = this.$loading({
                lock: true,
                text: '开始请求人机验证',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            //请求人机验证
            let r = await util.requestAuth(id)

            loading.close()
            if (!r) {
                this.$msgbox({
                    title: "提示",
                    message: '请求人机验证失败，请稍后重试'
                })
                return
            }
            this.authCode = r.md5
            this.qrCode = r.qrcode
            this.bShowCaptcha = true


            console.log("开始等待扫码验证")
            r = await util.waitAuth(this.authCode)

            console.log("扫码验证结果：", r)
            if (r.code == 1) {
                this.$msgbox({
                    title: "提示",
                    message: '人机验证二维码超时，请重试'
                })
                this.qrcode = ''
                this.bShowCaptcha = false
                return
            }

            this.bShowCaptcha = false
            this.qrCode = ''


            if (r.code != 0 || r.result != 1) {
                this.$msgbox({
                    title: "提示",
                    message: '人机验证失败或超时，请稍后重试'
                })
                this.qrcode = ''
                this.bShowCaptcha = false
                return
            }


            r = JSON.parse(r.data)

            console.log("授权结果：", r)

            util.InitCos(r)

            console.log("上传")

            r = await util.upload(id, text, (taskId) => {
                /* 非必须 */
                console.log("上传taskID:", taskId);
                _taskID = taskId
                this.bUploadDlg = true
            }, () => {
                /* 非必须 */

                this.uploadProgress = parseInt(info.percent * 10000) / 100;
                this.uploadSpeed = parseInt(info.speed / 1024 / 1024 * 100) / 100;
                console.log("progress:", info)
            })

            if (r) {
                this.uploadProgress = 100
                loading = this.$loading({
                    lock: true,
                    text: '正在提交...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                //注意，这里必须处理上传成功但提交失败的情况，那么就会出现
                //存储桶保存没有记录的死文件
                try {
                    r = await util.submit(id, this.delayCode) 
                } catch (error) {
                    console.log("提交失败：",error)
                    r = null
                }
               

                loading.close()
                if (!r) {
                    this.bUploadDlg = false
                    this.$msgbox({
                        title: '提示',
                        message: '上传失败，请稍后重试'
                    })
                } else {
                    console.log("提交结果：", r)
                    this.downloadUrl = util.getHost() + `/getfile?id=${id}`
                    this.content = ''
                    this.password = ''
                }
            } else {
                this.$msgbox({
                    title: '提示',
                    message: '上传失败，请稍后重试'
                })
            }



        },
        onDecryp() {
            if (!this.content) {
                this.$msgbox({
                    title: '错误',
                    message: '请先粘贴下载的加密信息'
                })
                return
            }
            if (!this.password) {
                this.$msgbox({
                    title: '错误',
                    message: '请输入解密密码'
                })
                return
            }

            let t = this.content
            let startIndex = t.indexOf("<p>") + 3;
            let endIndex = t.lastIndexOf("</p>");
            let s = t.substring(startIndex, endIndex);
            s = s.replace(/^\s+|\s+$/g, '');

            let text = util.Decrypted(this.password, s)
            this.content = text
            this.password = ''
        },
        onCancleUpload() {
            this.bUploadDlg = false
            if (!_taskID) return
            const cos = util.GetCosInstance()
            if (!cos) {
                return
            }
            cos.pauseTask(_taskID)
        },
        onShowCode() {
            this.bShowCode = !this.bShowCode
        },
        onCopyUrl() {
            if (!navigator.clipboard) {
                // Clipboard API not available
                this.$msgbox({
                    title: '无法拷贝链接',
                    type: 'error',
                    message: `请自行复制链接`
                })
                return
            }
            navigator.clipboard.writeText(this.downloadUrl)
                .then(() => {
                    this.$msgbox({
                        title: '已经拷贝到剪贴板',
                        type: 'success'
                    })
                    return
                })
                .catch(err => {
                    console.log("err:", err)
                    this.$msgbox({
                        title: '无法拷贝到剪贴板',
                        type: 'error'
                    })
                })
        },
        onUploadOK() {
            this.bUploadDlg = false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/home.vue